export default __webpack_public_path__ + "static/media/proj2_3.851c5872.jpg";